import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createSsmlEditorStore() {
  return {
    namespaced: true,
    
    state: () => ({
      isFocusInsideEditor: false,
      savedRange: null,
      content: '',
      currentLength: 0,
      activePlugins: [],
      defaultVoice: ''
    }),

    mutations: {
      SET_FOCUS_STATE(state, isFocus) {
        state.isFocusInsideEditor = isFocus
      },
      
      SET_RANGE(state, range) {
        state.savedRange = range
      },

      SET_CONTENT(state, content) {
        state.content = content
        state.currentLength = content.length
      },

      SET_ACTIVE_PLUGINS(state, plugins) {
        state.activePlugins = plugins
      },

      SET_DEFAULT_VOICE(state, voice) {
        state.defaultVoice = voice
      }
    },

    getters: {
      getSavedRange: state => state.savedRange,
      isFocusInsideEditor: state => state.isFocusInsideEditor,
      getDefaultVoice: state => state.defaultVoice
    }
  }
}